import { render, staticRenderFns } from "./subject-list.vue?vue&type=template&id=4289f0fa&"
import script from "./subject-list.ts?vue&type=script&lang=ts&"
export * from "./subject-list.ts?vue&type=script&lang=ts&"
import style0 from "./subject-list.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports